// extracted by mini-css-extract-plugin
export default {"layout":"aZO5Qa","layoutContent":"bZO5Qa"};